<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1> YONEX-SUNRISE G.H. Raisoni Memorial MARATHWADA OPEN Badminton Tournament 2025 </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2> <span> YONEX-SUNRISE G.H. Raisoni Memorial MARATHWADA OPEN Badminton Tournament 2025 </span>
            </h2>
        </div>
        <p><strong>This tournament was inaugurated by </strong> </p>
        <p> Hon. Shri Sanjay Shirsath</p>
        <p> Cabinet Minister, Social Justice, Government of Maharashtra</p>
        <p> & Guardian Minister, Chhatrapati Sambhajinagar</p>
        <p>Guests of Honour were</p>
        <p>Hon. Shri G. Shrikant, IAS</p>
        <p> Municipal Commissioner & Administrator, Chhatrapati Sambhajinagar</p>
        <p>Dr. Nitin Korde
            Dean (Academics), G. H. Raisoni College of Engineering & Management, Pune</p>
        <p>Chief Guests was
            Hon. Shri Siddharth Patil
            General Secretary, Maharashtra Badminton Association</p>

        <p>Chief Guest for Prize Distribution ceremony was
            Mr. Amit Sanap
            President, Sanap Group of industries</p>

        <p>Mr. Milind Deshmukh
            Refere, YONEX-SUNRISE G.H. Raisoni Memorial Marathwada Open Badminton Tournament 2025
        </p>

        <div class="col-md-12">
            <div class="sec-title mt-4 text-center">
                <h2><span>Photo Gallery</span></h2>
            </div>
            <div class="lightBox--gallery">
                <ul class="list-unstyled lightgallery justify-content-center row row-cols-1 row-cols-md-4">
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/marathwada-open/marathwada-open-1.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/marathwada-open/marathwada-open-1.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/marathwada-open/marathwada-open-1.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/marathwada-open/marathwada-open-2.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/marathwada-open/marathwada-open-2.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/marathwada-open/marathwada-open-2.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/marathwada-open/marathwada-open-3.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/marathwada-open/marathwada-open-3.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/marathwada-open/marathwada-open-3.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/marathwada-open/marathwada-open-4.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/marathwada-open/marathwada-open-4.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/marathwada-open/marathwada-open-4.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</section>

<section class="section section-sm result section-banner-bg-1">
    <div class="container">
        <div class="gall-ery shadow-soft">

            <div class="row  row-cols-1 row-cols-lg-4 ">
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/marathwada-open/final-report-marathwada-open-tornament-25.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Final Report Marathwada Open Tournament 2025</h4>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>
